import React, { useState } from 'react';
import { CustomerPaymentForm } from '../components/payments/CustomerPaymentForm';
import { PaymentsList } from '../components/payments/PaymentsList';

type PaymentMode = 'invoice' | 'customer' | 'history';

export const PaymentsPage: React.FC = () => {
  const [mode, setMode] = useState<PaymentMode>('customer');

  const handlePaymentSuccess = () => {
    window.location.reload();
  };

  const tabs: { key: PaymentMode; label: string }[] = [
    { key: 'customer', label: 'Customer Payment' },
    { key: 'invoice', label: 'Invoice Payment' },
    { key: 'history', label: 'Payment History' },
  ];

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
      {/* Page header */}
      <div style={{ paddingBottom: 20, borderBottom: '1px solid rgba(92,78,51,0.15)' }}>
        <div style={{ fontFamily: "'Inter', sans-serif", fontSize: 10, fontWeight: 400, letterSpacing: '0.4em', textTransform: 'uppercase', color: '#8a8778', marginBottom: 8 }}>
          Finance
        </div>
        <div style={{ fontFamily: "'Inter', sans-serif", fontSize: 36, fontWeight: 300, color: '#1c2033', lineHeight: 1 }}>
          Payments
        </div>
        <div style={{ fontFamily: "'Inter', sans-serif", fontSize: 13, fontWeight: 300, color: '#8a8778', marginTop: 8 }}>
          Record customer payments and allocate to invoices
        </div>
      </div>

      {/* Tab bar */}
      <div style={{ display: 'flex', gap: 2, background: 'rgba(241,245,249,1)', border: '1px solid rgba(92,78,51,0.2)', borderRadius: 6, padding: 4, width: 'fit-content' }}>
        {tabs.map(tab => (
          <button
            key={tab.key}
            onClick={() => setMode(tab.key)}
            style={{
              padding: '8px 20px',
              fontFamily: "'Inter', sans-serif",
              fontSize: 9,
              fontWeight: 500,
              letterSpacing: '0.18em',
              textTransform: 'uppercase',
              background: mode === tab.key ? 'linear-gradient(135deg, #d97706, #b45309)' : 'transparent',
              color: mode === tab.key ? '#1c2033' : '#8a8778',
              border: 'none',
              borderRadius: 4,
              cursor: 'pointer',
              transition: 'all 0.2s',
            }}
            onMouseEnter={e => { if (mode !== tab.key) (e.currentTarget as HTMLButtonElement).style.color = '#d97706'; }}
            onMouseLeave={e => { if (mode !== tab.key) (e.currentTarget as HTMLButtonElement).style.color = '#8a8778'; }}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Content */}
      {mode === 'customer' ? (
        <CustomerPaymentForm onSuccess={handlePaymentSuccess} onCancel={() => {}} />
      ) : mode === 'history' ? (
        <PaymentsList />
      ) : (
        <div style={{ maxWidth: 680, margin: '0 auto', width: '100%', background: '#ffffff', border: '1px solid rgba(92,78,51,0.25)', borderRadius: 8, overflow: 'hidden' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '20px 28px 16px', borderBottom: '1px solid rgba(92,78,51,0.15)' }}>
            <h3 style={{ fontFamily: "'Inter', sans-serif", fontSize: 20, fontWeight: 300, color: '#1c2033', margin: 0 }}>Invoice Payment</h3>
          </div>
          <div style={{ textAlign: 'center', padding: '40px 24px' }}>
            <svg width="48" height="48" fill="none" stroke="rgba(92,78,51,0.35)" viewBox="0 0 24 24" style={{ margin: '0 auto 16px' }}>
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
            <p style={{ fontFamily: "'Inter', sans-serif", fontSize: 13, color: '#6b6a5c', maxWidth: 420, margin: '0 auto 16px' }}>
              This mode is accessed from the invoice detail page. Use Customer Payment to record payments and allocate to multiple invoices.
            </p>
            <button
              onClick={() => setMode('customer')}
              style={{ fontFamily: "'Inter', sans-serif", fontSize: 9, letterSpacing: '0.18em', textTransform: 'uppercase', color: '#d97706', background: 'none', border: 'none', cursor: 'pointer' }}
            >
              Switch to Customer Payment →
            </button>
          </div>
        </div>
      )}
    </div>
  );
};
